<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but2" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but2" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>网银在线支付</span>
      <el-steps :active="3" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 填写付款信息" icon="el-icon-edit-outline"></el-step>
        <el-step title="2 网银操作" icon="el-icon-s-platform"></el-step>
        <el-step title="3 付款成功" icon="el-icon-s-check"></el-step>
        <el-step title="4 公司到账" icon="el-icon-success"></el-step>
      </el-steps>
      <div style="border:1px solid #EBEEF5;text-align: center;margin-top: 20px;">
        <img class="img" src="@/assets/images/icon_paying.png" alt=""/>
        <div style="margin-top: 20px">
          <p class="p1">请您在弹出页面中完成支付！</p>
        </div>
        <div class="button">
          <el-button class="but but3" @click="toPay">
            <span class="sp2">继续支付</span>
          </el-button>
          <el-button class="but but4" @click="toBuy">
            <span class="sp2">继续购物</span>
          </el-button>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data(){
    return{
      currentUser:'',
      saleOrgName: '',//销售组织
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    toPay(){
      this.$router.push({ path: "/finance/pay"});
    },
    toBuy(){
      this.$router.push({ path: "/product/buyFeed"})
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 90vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but2{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_pay{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    font-weight: bold;
  }
  .page{
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
  .img{
    margin-top: 50px;
    width: 153px;
    height: 127px;
  }
  .p1{
    margin-left: 10px;
    color: rgb(239, 51, 69);
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 3px;
  }
  .but{
    width: 144px;
    border-radius: 20px;
    border: none;
    height: 40px;
  }
  .but3{
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1) 0%,rgba(253,131,145,1) 100%);
  }
  .but4{
    background: linear-gradient(180.00deg, rgba(85,136,249,1) 0%,rgba(102,162,253,1) 100%);
  }
  .sp{
    font-weight: bold;
  }
  .sp1{
    font-weight: bold;
    color: rgb(240, 57, 74);
  }
  .sp2{
    color: rgb(255, 255, 255);
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
  }
  .button{
    width: 300px;
    margin: 50px auto;
    text-align: left;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    font-weight: bold;
    max-width: 100%;
  }
</style>
